import React from 'react';
import './Footer.css';
import footerlogo from '../../../Assets/Images/lendriva-logo.png';
import Twitter from "../../../Assets/Images/logo-twitter.svg";
import Facebook from '../../../Assets/Images/logo-facebook.svg';
import Instagram from '../../../Assets/Images/logo-instagram.svg';
import LinkedIn from '../../../Assets/Images/logo-linkedin.svg';

const Footer = () => {
    return (
        <div>
            <section className='footer'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="footer-logo">
                                <img src={footerlogo} alt="" className='img-fluid' />
                            </div>
                            <div className="concerns">
                                With lots of unique blocks, you can easily build a page without coding. Build your next landing page.
                            </div>
                            <div className='social-log d-flex'>
                                <img src={Twitter} alt="" className='img-fluid' />
                                <img src={Facebook} alt="" className='img-fluid' />
                                <img src={Instagram} alt="" className='img-fluid' />
                                <img src={LinkedIn} alt="" className='img-fluid' />
                            </div>
                        </div>
                        <div className="col-lg-8 footer-content">
                            <div className="row">
                                <div className="col-lg-3">
                                    <h5>Company</h5>
                                    <ul className='p-0 d-flex flex-column location-address'>
                                        <li><a href=""><span>About us</span>
                                        </a></li>
                                        <li><a href="">
                                            <span>Contact us</span></a></li>
                                        <li><a href=""><span>Careers</span></a></li>
                                        <li><a href=""><span>Press</span></a></li>
                                    </ul>
                                </div>
                                {/* <div className="col-lg-3">
                                    <h5>Product</h5>
                                    <ul className='p-0 d-flex flex-column'>
                                        <li><a href="">Features</a></li>
                                        <li><a href="">Pricing</a></li>
                                        <li><a href="">News</a></li>
                                        <li><a href="">Help desk</a></li>
                                        <li><a href="">Support</a></li>
                                    </ul>
                                </div>
                                <div className="col-lg-3">
                                    <h5>Services</h5>
                                    <ul className='p-0 d-flex flex-column'>
                                        <li><a href="">Digital Marketing</a></li>
                                        <li><a href="">Content Writing</a></li>
                                        <li><a href="">SEO for Business</a></li>
                                        <li><a href="">UI Design</a></li>
                                    </ul>
                                </div> */}
                                <div className="col-lg-3">
                                    <h5>Legal</h5>
                                    <ul className='p-0 d-flex flex-column'>
                                        <li><a href="/privacy-policy"><span>Privacy Policy</span></a></li>
                                        <li><a href="/terms-and-conditions"><span>Terms & Conditions</span></a></li>
                                        <li><a href=""><span>Return Policy</span></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='copyright'>
                <div className="container">
                    <div className="hr-line"></div>
                    <p className='m-0'>Copyright © {new Date().getFullYear()} Lendriva</p>

                </div>
            </section>
        </div>
    )
}

export default Footer